// extracted by mini-css-extract-plugin
export var footer = "_rn-0";
export var inherit = "_rn-1";
export var input = "_rn-2";
export var modalContent = "_rn-3";
export var quillEditor = "_rn-4";
export var subtitle = "_rn-5";